<!-- Linking Form -->
@if (linkForm) {
  <medsurf-design-form-control-form
    [formGroup]="linkForm"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column field">
      <label class="flex flex-grow-1">
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ 'global.linking' | translate }}
        </span>
      </label>
      <div medsurf-design-content-input-group>
        <!-- Type -->
        <medsurf-design-form-control-input-dropdown [formField]="false"
          [control]="linkForm.controls.type"
          [options]="FlatModels.LinkEntityModels.LinkTypeArray"
        [dropdownClass]="'medsurf-dropdown'"></medsurf-design-form-control-input-dropdown>
        <!-- Link -->
        @if (linkForm.value.type) {
          @if (linkForm.value.type === FlatModels.LinkEntityModels.LinkType.enum.Slide) {
            <medsurf-design-form-control-input-number
              [formField]="false"
              [control]="linkForm.controls.link"
              [class]="'w-full'"
            (valueChange)="onSubmit()"></medsurf-design-form-control-input-number>
          }
          @if (linkForm.value.type === FlatModels.LinkEntityModels.LinkType.enum.Site) {
            <medsurf-design-form-control-input-text
              [formField]="false"
              [control]="linkForm.controls.link"
              [class]="'w-full'"
            (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
          }
        }
      </div>
    </div>
  </medsurf-design-form-control-form>
}